import React from "react";
import styled from "styled-components";

// --- STYLED COMPONENTS ---

const ScoreWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  background: #ffffff;
  border: 1px solid #eee;
  padding: 40px;
  transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
  cursor: default;



  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 30px 20px;
  }
`;

/* LEWA DRUŻYNA - Nazwa po lewej, Logo po prawej */
const TeamLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;

  @media (max-width: 768px) {
    /* Na mobile odwracamy oś, by Logo było nad Nazwą */
    flex-direction: column-reverse; 
    justify-content: center;
    gap: 15px;
  }
`;

/* PRAWA DRUŻYNA - Logo po lewej, Nazwa po prawej */
const TeamRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;

  @media (max-width: 768px) {
    /* Na mobile standardowa oś: Logo nad Nazwą */
    flex-direction: column; 
    justify-content: center;
    gap: 15px;
  }
`;

const TeamName = styled.span`
  font-size: clamp(1.2rem, 3vw, 2rem);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: -1px;
  color: #111;
  text-align: center;
`;

const LogoWrapper = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #f9f9f9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* Subtelne wykorzystanie koloru drużyny jako obrysu */
  border: 3px solid ${props => props.accentColor || "#eee"};
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }

  img {
    width: 75%;
    height: 75%;
    object-fit: contain;
    filter: grayscale(100%);
    transition: all 0.4s ease;
  }
`;

const ScoreCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 0 40px;

  @media (max-width: 768px) {
    padding: 20px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }
`;

const Points = styled.div`
  font-size: clamp(3rem, 6vw, 4.5rem);
  font-weight: 900;
  line-height: 1;
  color: #111;
  width: 60px;
  text-align: center;
  font-variant-numeric: tabular-nums; /* Zapobiega skakaniu cyfr */
`;

const Divider = styled.div`
  font-size: 2.5rem;
  font-weight: 300;
  color: #ccc;
  margin-top: -5px; /* Drobna korekta wizualna dla dwukropka/myślnika */
`;


// --- KOMPONENT ---

const MatchScore = ({
  team1Name,
  team1Color,
  team1Points,
  team1Logo,
  team2Name,
  team2Color,
  team2Points,
  team2Logo
}) => {

  // Zabezpieczenie przed brakiem punktów (np. dla meczu, który się jeszcze nie odbył)
  const score1 = team1Points !== undefined && team1Points !== null ? team1Points : "-";
  const score2 = team2Points !== undefined && team2Points !== null ? team2Points : "-";

  return (
    <ScoreWrapper>
      
      {/* DRUŻYNA 1 (Gospodarze) */}
      <TeamLeft>
        <TeamName>{team1Name}</TeamName>
        <LogoWrapper accentColor={team1Color}>
          <img src={team1Logo || "../icons/hockey.svg"} alt={`${team1Name} logo`} />
        </LogoWrapper>
      </TeamLeft>

      {/* ŚRODEK (Wynik) */}
      <ScoreCenter>
        <Points>{score1}</Points>
        <Divider>:</Divider>
        <Points>{score2}</Points>
      </ScoreCenter>

      {/* DRUŻYNA 2 (Goście) */}
      <TeamRight>
        <LogoWrapper accentColor={team2Color}>
          <img src={team2Logo || "../icons/hockey.svg"} alt={`${team2Name} logo`} />
        </LogoWrapper>
        <TeamName>{team2Name}</TeamName>
      </TeamRight>

    </ScoreWrapper>
  );
};

export default MatchScore;